import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SubscriptionFormViewModel } from '~app/farp-odq/store/subscription/subscription.model';

@Component({
    selector: 'odq-premium',
    templateUrl: './premium.component.html',
    styleUrls: ['./premium.component.scss', '../styles/subscription-forms.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PremiumComponent {
  @Input() model: SubscriptionFormViewModel;
  @Input() inactiveMemberForSubscription: boolean;
}